export const useGroupsFilter = () => {
  const groupIds = useRouteQuery<string>('groupIds', '');
  const handleGroupIdsUpdate = (value: string[]) => {
    groupIds.value = value.join(',');
  };
  const groupIdsAsArray = computed(() => {
    return String(groupIds.value)
      .split(',')
      .filter((value) => value.length);
  });

  return {
    handleGroupIdsUpdate,
    groupIdsAsArray,
    groupIds,
  };
};
